// extracted by mini-css-extract-plugin
export default {"grid":"_P6AG6","container":"W79myD"};